import React from 'react';
import { Link } from 'react-router-dom';

const IncreasePageRead = ({ param1, param2 }) => {  

return (
  <>
      <div className='mt-12'>
        <h2 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Increase Page Read</h2>
      </div>
      <div className="flex flex-col items-center justify-center ml-4 mr-4 mt-4 mb-4 text-white text-sm">
        <div className='mt-4 text-xl bg-blue-600 w-auto px-4 items-center'>
            <Link to="/wallet-mywallet" className='justify-center'>View Wallet</Link>
        </div>
      </div>
    </>
  );
}


export default IncreasePageRead;

